export default "/images/my-church-profile-slider.svg?0645fc7a971e26547e0a9291e06c1fa2";